import { Component, Input, EventEmitter } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService,
    UserCreate, PlatformService
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController, Select } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the DateFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'date-filter',
    templateUrl: 'date-filter.html'
})
export class DateFilterComponent extends BaseComponent {
    monthFilterOptions: { Month: string, Position: string; IsSelected: boolean; DisplayFlag?: boolean }[];
    yearFilterOptions: { Year: string, IsSelected: boolean; DisplayFlag?: boolean }[];
    selectedMonths: string[];
    selectedYears: string[];
    dateFilterApplied: (
        filterA: { Year: string, IsSelected: boolean }[],
        filterB: { Month: string, Position: string; IsSelected: boolean }[]
    ) => void;

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected popoverCtrl: PopoverController,
        protected platformService: PlatformService,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {

        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "DateFilterComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();
        this.dateFilterApplied = this.navParams.get("dateFilterApply");
        this.yearFilterOptions = this.navParams.get("yearFilterOptions");
        this.monthFilterOptions = this.navParams.get("monthFilterOptions");
        this.selectedMonths = this.monthFilterOptions.filter(f => f.IsSelected).map(i => i.Position);
        this.selectedYears = this.yearFilterOptions.filter(f => f.IsSelected).map(i => i.Year);

        this.notificationsService.notifyFilteredEventsAvailable(false);
        this.notificationsService.filteredEventsAvailable$
            .takeUntil(this.componentDestroyed$)
            .subscribe((value) => {
                if (value) {
                    this.close();
                }
            });
    }

    close(): void {
        this.viewCtrl.dismiss();
    }

    triggerFilterApply(): void {
        this.monthFilterOptions.forEach((p) => {
            p.IsSelected = false;
        });

        this.yearFilterOptions.forEach((p) => {
            p.IsSelected = false;
        });

        var selectedMonths = this.monthFilterOptions.filter(option => (this.selectedMonths || []).indexOf(option.Position) > -1);
        selectedMonths.forEach(p => {
            p.IsSelected = true;
        });

        var selectedYears = this.yearFilterOptions.filter(option => (this.selectedYears || []).indexOf(option.Year) > -1);
        selectedYears.forEach(y => {
            y.IsSelected = true;
        });

        this.loggingService.debug("Selected MONTHS, YEARS=>", this.selectedMonths, this.selectedYears);
        this.dateFilterApplied(selectedYears, selectedMonths);      
    }

    resetYearSelection(): void {
        this.yearFilterOptions.forEach(function (option) {
            option.IsSelected = false;
            option.DisplayFlag = false;
        });
        this.selectedYears = [];
    }


    resetMonthSelection(): void {
        this.monthFilterOptions.forEach(function (option) {
            option.IsSelected = false;
            option.DisplayFlag = false;
        });
        this.selectedMonths = [];
    }
}



// WEBPACK FOOTER //
// ./src/components/date-filter/date-filter.ts